import DashboardPage from "@/pages/Dashboard";

export default [
  {
    path: "/changeplan",
    name: "ChangePlan",
    component: DashboardPage,
    props: {
      dashboardPage: "company",
      headerMode: "full",
      subPage: "changePlan",
      planPage: "ultimate"
    }
  },
  {
    path: "/changeplanbasic",
    name: "ChangePlanBasic",
    component: DashboardPage,
    props: {
      dashboardPage: "company",
      headerMode: "full",
      subPage: "changePlan",
      planPage: "basic"
    }
  },
  {
    path: "/changeplanfree",
    name: "ChangePlanFree",
    component: DashboardPage,
    props: {
      dashboardPage: "company",
      headerMode: "full",
      subPage: "changePlan",
      planPage: "free"
    }
  },
  {
    path: "/pricing",
    name: "PricingPage",
    component: DashboardPage,
    props: {
      dashboardPage: "company",
      headerMode: "full",
      subPage: "pricing"
    }
  }
];
